import { LOADING, PAGINATION_LOADING } from "./types";
// Set Loading
export const setLoading = () => {
    return {
        type: LOADING
    };
}
export const setPaginationLoading = () => {
    return {
        type: PAGINATION_LOADING
    };
}